import React from 'react'
import Promotion from '@/components/sections/Promotion'
import IconList from '@/components/subComponents/iconList'
import Meta from '@/components/common/Meta'
import FindStorage from '@/components/subComponents/findStorage'
import FeatureBox from '@/components/subComponents/FeatureBox'
import Link from 'next/link'
import { BOOK_NOW } from '@/router/allUrls'
import { assets } from '@/helpers/common'
import BusinessStorageBanner from '@/components/banners/BusinessStorageBanner'
import { META_CONTENTS } from '@/v1/constants/seo'

const for_whom = [
  {
    title: 'Trade Show Material',
    icon: assets('images/business-storage/for-whom-01.png'),
    content:
      'If you are going to travel for business purpose? And want to store your trade show materials then we can help you. You can conveniently store your tradeshow materials with our trade show storage services in a better, cheaper, and faster way.'
  },

  {
    title: 'Home Service Businesses',
    icon: assets('images/business-storage/for-whom-02.png'),
    content:
      "To handle materials and parts, equipment, and other documents some home service firms require a lot of storage space. That's where our home service storage service comes in handy."
  },

  {
    title: 'E-Commerce Businesses',
    icon: assets('images/business-storage/for-whom-03.png'),
    content:
      'The requirement for an office outside of the home has been eliminated for many e-commerce firms by just renting a storage unit. For small to large business owners wanting to launch e-Commerce business, our e-Commerce storage or retail storage services can be an ideal solution.'
  },

  {
    title: 'Office Document Storage',
    icon: assets('images/business-storage/for-whom-05.png'),
    content:
      'Many professional offices (lawyers and doctors, for instance) are required to have business storage of documents and records for up to 5-10 years or more! '
  },

  {
    title: 'Pharmaceutical Sales Representatives',
    icon: assets('images/business-storage/for-whom-04.png'),
    content:
      "Instead of finding office space, pharmaceutical companies have begun to use self-storage facilities to meet the demands of pharmaceutical sales representatives. That's why our pharmaceutical storage service is highly recommended for those pharmaceutical companies."
  },

  {
    title: 'Retails Businesses',
    icon: assets('images/business-storage/for-whom-06.png'),
    content:
      'Retail businesses often rent business storage units. But Commercial retail space is expensive, only our smart storage service can minimize your cost. Retail businesses that use business storage include: Clothing, boutiques, Electronics stores, Office equipment companies.'
  }
]
const grab_our_facilities = [
  {
    title: 'Lower Cost',
    icon: assets('images/business-storage/grab-our-facilities-01.png'),
    content:
      'No need to pay higher for expensive office spaces! You store your office documents with us in a cheaper way. We just charge for boxes, not for space! Simply pack your equipment and documents safely in a box and store with us.'
  },

  {
    title: 'Use Our  Secure Storage Unit As an Online Shop?',
    icon: assets('images/business-storage/grab-our-facilities-02.png'),
    content:
      'Yes, you can use our inventory storage unit as an Online Shop. Storage units can be used to store commercial items, as well as you can ship your items to your customers wherever and whenever in the world!'
  },

  {
    title: 'Delivery and Package Acceptance',
    icon: assets('images/business-storage/grab-our-facilities-03.png'),
    content:
      'We can receive or ship any of your documents. You do not need to come directly to our facility. Which is a huge benefit if you want to utilize it to keep inventory or materials.'
  },

  {
    title: 'Easy to store, easy to move',
    icon: assets('images/business-storage/grab-our-facilities-04.png'),
    content:
      'Your storage materials can be dropped off and picked up conveniently on your schedule. And, should you need to ship your boxes for any reason, our team of expert are ready to help.'
  },

  {
    title: 'Facility Security Measures',
    icon: assets('images/business-storage/grab-our-facilities-05.png'),
    content:
      'Our smart storage solutions use digital surveillance monitoring and key coded entry/access systems to keep an eye on facility activity and deter would-be trespassers. '
  }
]
const safe_service = [
  { title: 'Biometric System Acces', icon: assets('images/book-now/safe_service_icon_01.png'), content: false },
  { title: 'Insurance Coverage', icon: assets('images/book-now/safe_service_icon_05.png'), content: false },
  {
    title: 'Barcode Tracking System',
    icon: assets('images/book-now/safe_service_icon_02.png'),
    content: false
  },
  { title: 'Fire Control', icon: assets('images/book-now/safe_service_icon_06.png'), content: false },
  { title: 'Pest Control', icon: assets('images/book-now/safe_service_icon_03.png'), content: false },
  { title: 'CCTV Monitoring', icon: assets('images/book-now/safe_service_icon_07.png'), content: false },
  { title: 'Pickup from Door Step', icon: assets('images/book-now/safe_service_icon_04.png'), content: false },
  { title: '24/7 Security', icon: assets('images/book-now/safe_service_icon_08.png'), content: false }
]

function BusinessStorage() {
  return (
    <>
      <Meta
        title={META_CONTENTS.business_storage_solution.title}
        keywords={META_CONTENTS.business_storage_solution.keywords}
        description={META_CONTENTS.business_storage_solution.description}
      />

      <BusinessStorageBanner />

      <section className='pt-16 xl:pt-0 find-storage-section'>
        <div className='container'>
          <div className='row justify-center'>
            <FindStorage className='inline-block -mt-10 sm-mx:-mt-7' />
          </div>
        </div>
      </section>

      <section className='mobile-banner-content-section lg-mn:hidden pt-16 sm-mx:pt-12 sm-mx:pb-2'>
        <div className='container mx-auto'>
          <div className='row sm-mx:flex-col-reverse'>
            <div className='w-full text-center'>
              <div className='banner-content text-center'>
                <h2 className='text-4xl2 sm-mx:text-2xl26 font-bold text-secondary mb-4'>Business Storage Solution</h2>
                <h3 className='text-2xl sm-mx:text-lg font-normal text-gray-400 mb-1'>
                  Do you need additional storage space for your growing business? Use our smart storage solution that is{' '}
                  <br />
                  <span className='font-bold text-secondary'>FREE up to 6 Months!</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='for-whom-section pt-24 pb-14 md-mx:pt-12 sm-mx:pt-10'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full md-mx:w-11/12 text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>For Whom?</h2>
                <p>
                  We know your company is continually evolving and expanding! And you may need some extra space with
                  low-cost
                  <br className='lg-mx:hidden' /> commercial storage facility. No worry! We got you covered with our
                  smart storage and worldwide shipping solution.
                </p>
              </div>
            </div>
          </div>
          <div className='pt-20 md grid gap-y-10 lg-mx:gap-y-5 grid-cols-3 md-mx:grid-cols-2 xs:grid-cols-1'>
            {for_whom.map((item, key) => {
              return (
                <div key={key} className='px-5 lg-mx:px-0 text-center'>
                  <FeatureBox className='style-two' title={item.title} icon={item.icon} content={item.content} />
                </div>
              )
            })}
          </div>
        </div>
      </section>

      <section className='grab-our-facilities-section bg-white-ice-two pt-24 pb-14 md-mx:pt-12 sm-mx:pt-10 sm-mx:pb-5'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>Grab Our Facilities </h2>
                <p>
                  Our smart storage and shipping solution is perfect for your business storage space needs. Our storage
                  units are a great value for storing business files, extra product inventory, equipment, and more.
                </p>
              </div>
            </div>
          </div>
          <div className='row flex flex-flow justify-around md-mx:justify-center pt-16'>
            {grab_our_facilities.map((item, key) => {
              return (
                <div key={key} className='w-4/12 md-mx:w-6/12 xs:w-full px-4 lg-mx:px-0 text-center'>
                  <FeatureBox className='style-two' title={item.title} icon={item.icon} content={item.content} />
                </div>
              )
            })}
          </div>
        </div>
      </section>

      <section className='store-documents-section pt-14 pb-14 sm-mx:pt-7 sm-mx:pb-7'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='store-documents-box text-center'>
              <div className='section-title effect text-center mb-14 sm-mx:mb-8'>
                <h2 className='inline-block'>Tips For Storing Documents</h2>
              </div>
              <ul className='list-style-one text-left'>
                <li>Use expandable file folders or binders to store documents.</li>
                <li>Store documents in a fireproof and waterproof locked safe.</li>
                <li>To avoid mold, mildew, or water damage, use airtight packaging.</li>
                <li>Use waterproof labels on your boxes.</li>
                <li>Scan papers and store them digitally in a separate location.</li>
                <li>Do not wrap or cushion your documents with newspaper.</li>
              </ul>
              <Link href={BOOK_NOW} className='btn btn-primary get-started shadow sm-mx:mt-3'>
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className='safe-services-section sm-mx:bg-white-ice  pt-14 pb-14 md-mx:pt-12 sm-mx:pt-7 sm-mx:pb-7'>
        <div className='container'>
          <div className='row md-mx:flex-col-reverse'>
            <div className='w-6/12 md-mx:w-full md-mx:text-center sm-mx:text-left'>
              <div className='section-title'>
                <h2>
                  Safe, secure, reliable and <br />
                  affordable storage service
                </h2>
              </div>
              <p>
                Ship and Storage is storage space provider to stow all your household items with state of the art
                security facilities, Catering exclusive cheap storage solutions ranging from Household items storage to
              </p>
              <IconList listData={safe_service} linkDisable listIcon />
            </div>
            <div className='w-6/12 md-mx:w-full text-right md-mx:text-center sm-mx:hidden'>
              <img src={assets('images/book-now/safe_services.png')} className='inline-block' alt={`safe-services`} />
            </div>
          </div>
        </div>
      </section>

      <Promotion className='sm-mx:mt-5' />
    </>
  )
}

export default BusinessStorage
